export const app_main_routing_menu = {
  login: { title: 'Login', path: 'login' },
  signin: { title: 'Signin', path: 'signin' },
  forbidden: { title: 'Forbidden', path: 'forbidden' },
  activate: { title: 'Activate Account', path: 'activate' },
  switchTenant: { title: 'Switch Tenant', path: 'switch-tenant' },
  audience_manager: { title: 'Audience Manager', path: 'audience-manager' },
};
